<kilowant-header [isSeller]="isSeller" [isBuyer]="!isSeller" [linkHome]="linkHome" [title]="title" [showAccountList]="false"></kilowant-header>
@if (contract != null || existingContract != null) {
<div class="wrapperMain mainAccountDetailsMain accountDetails">
    <div class="form buyer">
        <div class="card">
            <div class="body">
                <div class="table-view">
                    <div class="row">
                        <div class="cell cell-header mat-mdc-cell" style="border-bottom: none;">Supplier Name</div>
                        <div class="cell cell-header mat-mdc-cell" style="border-bottom: none;">$/kWh</div>
                        <div class="cell cell-header mat-mdc-cell" style="border-bottom: none;">Service Start</div>
                        <div class="cell cell-header mat-mdc-cell" style="border-bottom: none;">Service End</div>
                        @if (isKilowantContract) {
                        <div class="cell cell-header mat-mdc-cell" style="border-bottom: none;">Offer Date</div>
                        }
                    </div>
                    @if (isKilowantContract && contract) {
                    <div class="row">
                        <div class="cell mat-mdc-cell f13 text-center">{{contract.supplierName}}</div>
                        <div class="cell mat-mdc-cell f13 text-center">{{contract.getSalesPrice() | currency:'USD':'symbol':'1.5-5'}}</div>
                        <div class="cell mat-mdc-cell f13 text-center">{{contract.termFrom | date:'shortDate'}}</div>
                        <div class="cell mat-mdc-cell f13 text-center">{{contract.termTo | date:'shortDate'}}</div>
                        <div class="cell mat-mdc-cell f13 text-center">{{$any(contract).dateEntered | date:'shortDate'}}</div>
                    </div>
                    }
                    @if (!isKilowantContract && existingContract) {
                    <div class="row">
                        <div class="cell mat-mdc-cell f13 text-center">{{existingContract.supplierName}}</div>
                        <div class="cell mat-mdc-cell f13 text-center">{{existingContract.getSalesPrice() | currency:'USD':'symbol':'1.5-5'}}</div>
                        <div class="cell mat-mdc-cell f13 text-center">{{existingContract.termFrom | date:'shortDate'}}</div>
                        <div class="cell mat-mdc-cell f13 text-center">{{existingContract.termTo | date:'shortDate'}}</div>
                    </div>
                    }
                </div>
            </div>
            <div class="body" #body>
                @if (!isSeller) {
                @if (contract) {
                <kilowant-user-home-price-statistics [contract]="contract"></kilowant-user-home-price-statistics>
                }
                @if (priceHistoryLoaded && contractSaving && ((isKilowantContract && contract) || (!isKilowantContract && existingContract))) {
                @if (contractSaving.saveVsEnergy > 0) {
                <div class="price-info chat-info-shadow selected button red mt-10">
                    @if (((isKilowantContract) && (contract!.termFrom != null && contract!.termTo! > currentDate.toJSDate())) ||
                    ((!isKilowantContract) && (existingContract!.termFrom != null && existingContract!.termTo! > currentDate.toJSDate()))) {
                    You are projected to save
                    }
                    @if (((isKilowantContract) && (contract!.termFrom == null || contract!.termTo! <= currentDate.toJSDate())) ||
                    ((!isKilowantContract) && (existingContract!.termFrom == null || existingContract!.termTo! <= currentDate.toJSDate()))) {
                    You have saved
                    }
                    @if (contractSaving.saveVsEnergyInUSD > 0) {
                    ${{contractSaving.saveVsEnergyInUSD}} ({{contractSaving.saveVsEnergy}}%) vs. RI Energy Last Resort Service
                    }
                    @if (contractSaving.saveVsEnergyInUSD <= 0) {
                    {{contractSaving.saveVsEnergy}}% vs. RI Energy Last Resort Service
                    }
                    @if (((isKilowantContract) && (contractSaving.saveVsCommunity != null && contractSaving.saveVsCommunity > 0 && contract!.accounts[0].isCommunity)) ||
                    ((!isKilowantContract) && (contractSaving.saveVsCommunity != null && contractSaving.saveVsCommunity > 0 && existingContract!.accounts[0].isCommunity))) {
                    and
                    @if (contractSaving.saveVsCommunityInUSD > 0) {
                    ${{contractSaving.saveVsCommunityInUSD}} ({{contractSaving.saveVsCommunity}}%) vs. NextEra Energy
                    }
                    @if (contractSaving.saveVsCommunityInUSD <= 0) {
                    {{contractSaving.saveVsCommunity}}% vs. NextEra Energy
                    }
                    }
                </div>
                }
                @if (contractSaving.saveVsEnergy > 0) {
                <div class="price-callout-bottom ng-star-inserted"><svg width="60" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" class="chat-info-shadow"><g><path stroke-width="1" d="M15 0 L60 0 L0 60" stroke="#ff8181" fill="#ff8181"></path></g></svg></div>
                }
                @if (contractSaving.saveVsEnergy <= 0) {
                <div class="mt-50"></div>
                }
                <div class="price-history owl-theme">
                    <div class="right-margin-icon top info-icon" style="margin-top: -20px" (click)="iIconPopup(getRatingText(latestUtilityDate, latestCommunityDate));"></div>
                    <kilowant-charts-home-accept-offer [view]="view" [legend]="legend" [legendTitle]="legendTitle"
                                                       [legendPosition]="legendPosition" [showGridLines]="true" [showDataLabel]="false"
                                                       [scheme]="colorScheme" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                                                       [xAxis]="xAxis" [yAxis]="true" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                                                       [groupPadding]="2" [barPadding]="1"
                                                       [prefix]="'0'"
                                                       [results]="loadedRates"
                                                       [valLabel]="'Contract'"
                                                       [val]="[(isKilowantContract) ? contract!.getSalesPrice() : existingContract!.getSalesPrice()]"
                                                       [shadow]="true"
                                                       [utilityAverageRate]="contractSaving.utilityRate"
                                                       [communityAverageRate]="contractSaving.communityRate"
                                                       [valColor]="'#ff8181'"
                                                       [leftShift]="[]"
                                                       [rightShift]="[]"
                                                       [selectedDatasets]="selectedDatasets"
                                                       [showNormalChatout]="false"
                                                       [tooltipDisabled]="true"
                                                       [utilityWarningDate]="latestUtilityDate"
                                                       [communityWarningDate]="latestCommunityDate">
                    </kilowant-charts-home-accept-offer>
                </div>
                }
                }
            </div>
            @if (isKilowantContract && contract) {
            <div class="body mt-10">
                <div class="account-info-block">
                    <p class="card-block-background link" (click)="viewSummary=!viewSummary">
                        TRANSACTION SUMMARY
                        <a [class]="(viewSummary)?'collapse':'open'"></a>
                    </p>
                    <div [class]="(viewSummary)?'visible':'hidden'">
                        <p class="accountInfoBorder">{{contract.detailsUtility || '-'}} &gt; {{contract.detailsLoadZone || '-'}} &gt; {{contract.detailsRateClass || '-'}}</p>
                        @for (accountData of contract.accounts; track accountData; let r = $index) {
                        <div class="subUniqueTitle d-flex">
                            <div>{{(r+1)}}.</div>
                            <div class="auto long-text-cut">{{getAccountIdent(accountData)}}</div>
                        </div>
                        }
                        <p class="accountInfoBorder">Product Type</p>
                        <p class="subUniqueTitle">{{contract.detailsProductType || '-'}}</p>
                        <p class="accountInfoBorder">Price</p>
                        <p class="subUniqueTitle">{{contract.getSalesPrice() | currency:'USD':'symbol':'1.5-5'}}/kWh</p>
                        <p class="accountInfoBorder">Service Start</p>
                        <p class="subUniqueTitle">1st meter read on or after {{contract.termFrom | date:'shortDate'}}</p>
                        <p class="accountInfoBorder">Service End</p>
                        <p class="subUniqueTitle">1st meter read on or after {{contract.termTo | date:'shortDate'}}</p>
                        @if (contract.disclosureStatement!=null && contract.disclosureStatement.length>0) {
                        <div class="card-sub-block-background mt-20">DISCLOSURE STATEMENT</div>
                        <div class="p-10 f13" [innerHTML]="contract.disclosureStatement"></div>
                        }
                    </div>
                </div>
                <div class="account-info-block">
                    <p class="card-block-background" [class]="(viewTerms)?'link':'link view-closed'" (click)="viewTerms=!viewTerms">
                        SALES AGREEMENT
                        <a [class]="(viewTerms)?'collapse':'open'"></a>
                    </p>
                    <div [class]="(viewTerms)?'visible':'hidden'">
                        @if (contractTerms!=null) {
                        <div class="f13 long-text-cut text-nowarp p-10">
                            <b>HASH:</b> {{contract.termsHash}}
                        </div>
                        }

                        <div class="table-view mt-10">
                            <!-- Header Row -->
                            <div class="row">
                                <div class="cell">
                                    <div class="card-sub-block-background">BUYER</div>
                                </div>
                                <div class="cell">
                                    <div class="card-sub-block-background">SELLER</div>
                                </div>
                            </div>

                            <!-- First Name -->
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">First Name</p>
                                </div>
                                <div class="cell f13">
                                    <p class="accountInfoBorder">First Name</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsBuyerFirstName || '-'">{{contract.detailsBuyerFirstName || '-'}}</p>
                                </div>
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsSellerFirstName || '-'">{{contract.detailsSellerFirstName || '-'}}</p>
                                </div>
                            </div>

                            <!-- Last Name -->
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Last Name</p>
                                </div>
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Last Name</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsBuyerLastName || '-'">{{contract.detailsBuyerLastName || '-'}}</p>
                                </div>
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsSellerLastName || '-'">{{contract.detailsSellerLastName || '-'}}</p>
                                </div>
                            </div>

                            <!-- Company Name -->
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Company Name</p>
                                </div>
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Company Name</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsBuyerCompanyName || '-'">{{contract.detailsBuyerCompanyName || '-'}}</p>
                                </div>
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsSellerCompanyName || '-'">{{contract.detailsSellerCompanyName || '-'}}</p>
                                </div>
                            </div>

                            <!-- Address Line 1 -->
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Address Line 1</p>
                                </div>
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Address Line 1</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsBuyerAddressLine1 || '-'">{{contract.detailsBuyerAddressLine1 || '-'}}</p>
                                </div>
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsSellerAddressLine1 || '-'">{{contract.detailsSellerAddressLine1 || '-'}}</p>
                                </div>
                            </div>

                            <!-- Address Line 2 -->
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Address Line 2</p>
                                </div>
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Address Line 2</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsBuyerAddressLine2 || '-'">{{contract.detailsBuyerAddressLine2 || '-'}}</p>
                                </div>
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsSellerAddressLine2 || '-'">{{contract.detailsSellerAddressLine2 || '-'}}</p>
                                </div>
                            </div>

                            <!-- City -->
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">City</p>
                                </div>
                                <div class="cell f13">
                                    <p class="accountInfoBorder">City</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsBuyerCity || '-'">{{contract.detailsBuyerCity || '-'}}</p>
                                </div>
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsSellerCity || '-'">{{contract.detailsSellerCity || '-'}}</p>
                                </div>
                            </div>

                            <!-- State -->
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">State</p>
                                </div>
                                <div class="cell f13">
                                    <p class="accountInfoBorder">State</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="(contract.detailsBuyerState != null) ? contract.detailsBuyerState.name : '-'">{{(contract.detailsBuyerState != null) ? contract.detailsBuyerState.name : '-'}}</p>
                                </div>
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="(contract.detailsSellerState != null) ? contract.detailsSellerState.name : '-'">{{(contract.detailsSellerState != null) ? contract.detailsSellerState.name : '-'}}</p>
                                </div>
                            </div>

                            <!-- Zip -->
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Zip</p>
                                </div>
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Zip</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsBuyerZip || '-'">{{contract.detailsBuyerZip || '-'}}</p>
                                </div>
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsSellerZip || '-'">{{contract.detailsSellerZip || '-'}}</p>
                                </div>
                            </div>

                            <!-- Telephone -->
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Telephone</p>
                                </div>
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Telephone</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsBuyerPhone || '-'">{{contract.detailsBuyerPhone || '-'}}</p>
                                </div>
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsSellerPhone || '-'">{{contract.detailsSellerPhone || '-'}}</p>
                                </div>
                            </div>

                            <!-- E-mail -->
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">E-mail</p>
                                </div>
                                <div class="cell f13">
                                    <p class="accountInfoBorder">E-mail</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsBuyerEmail || '-'">{{contract.detailsBuyerEmail || '-'}}</p>
                                </div>
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsSellerEmail || '-'">{{contract.detailsSellerEmail || '-'}}</p>
                                </div>
                            </div>

                            <!-- Tax Exempt & Federal Tax ID (Buyer only) -->
                            @if (contract.detailsBuyerTaxExempt) {
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Tax Exempt</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle">Yes</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="accountInfoBorder">Federal Tax ID</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="cell f13">
                                    <p class="subUniqueTitle" [attr.title]="contract.detailsBuyerFederalTaxID || '-'">{{contract.detailsBuyerFederalTaxID || '-'}}</p>
                                </div>
                            </div>
                            }
                        </div>
                        <div class="p-10 f13">
                            <b>Both Buyer and Seller agree to the above transaction governed by the Terms &amp; Conditions: </b><br /><br />
                            @if (contract.termsDocument != null) {
                            <div><a><b>Download</b></a></div>
                            }
                            @if (contractTerms!=null) {
                            <div class="f13" [innerHTML]="contractTerms"></div>
                            }
                        </div>
                        <div class="p-10">
                            @if (contract.isCancelled()) {
                            <div class="mt-10">
                                @if (contract.cancelledByBuyer || contract.cancelledBySeller) {
                                <p class="mb-10"><b>This contract was cancelled {{cancelledBy(contract)}}</b></p>
                                }
                                @if (!contract.cancelledByBuyer && !contract.cancelledBySeller) {
                                <p class="mb-10"><b>This price plan was not confirmed</b></p>
                                }
                            </div>
                            }
                            @if (contractIsSigned(contract.status)) {
                            <div class="mt-10 table-view">
                                <div class="row">
                                    <div class="cell">
                                        <div class="font13 long-text-cut ">By Buyer: {{contract.buyerSignedUserEmail || '-'}}</div>
                                        <div class="font13 long-text-cut ">on {{contract.confirmedByBuyerDate | date:'short'}} EST</div>
                                        <div class="font13 long-text-cut ">IP: {{contract.buyerSignedIP || '-'}}</div>
                                    </div>
                                    <div class="cell">
                                        <div class="font13 long-text-cut ">By Seller: {{contract.sellerSignedUserEmail}}</div>
                                        <div class="font13 long-text-cut ">on {{contract.confirmedDate | date:'short'}} EST</div>
                                        <div class="font13 long-text-cut ">IP: {{contract.sellerSignedIP || '-'}}</div>
                                    </div>
                                </div>
                            </div>
                            }
                            @if (contractIsNonVerified(contract.status)) {
                            <div class="mt-10 table-view">
                                <div class="cell">
                                    <div class="font13 long-text-cut ">By Buyer: {{contract.buyerSignedUserEmail}}</div>
                                    <div class="font13 long-text-cut ">on {{contract.confirmedByBuyerDate | date:'short'}} EST</div>
                                    <div class="font13 long-text-cut ">IP: {{contract.buyerSignedIP}}</div>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                
                <div class="mt-10 block-buttons full-width under-card">
                    <button type="button" (click)="exportContract(contract)">Download Sales Agreement</button>
                    @if (contract.canBeCancelled && !isSeller) {
                    <button type="button" (click)="cancelContract(contract)">Cancel Price Plan</button>
                    }
                </div>                
            </div>
            }

            @if (!isKilowantContract && existingContract) {
            <div class="body mt-10">
                <div class="account-info-block">
                    <p class="card-block-background link" (click)="viewSummary=!viewSummary">
                        TRANSACTION SUMMARY
                        <a [class]="(viewSummary)?'collapse':'open'"></a>
                    </p>
                    <div [class]="(viewSummary)?'visible':'hidden'">
                        <p class="accountInfoBorder">Utility</p>
                        <p class="subUniqueTitle">{{existingContract.accounts[0].utility!.name || '-'}}</p>
                        <p class="accountInfoBorder">Load Zone</p>
                        <p class="subUniqueTitle">{{existingContract.accounts[0].loadZone!.name || '-'}}</p>
                        <p class="accountInfoBorder">Rate Class(es)</p>
                        <p class="subUniqueTitle">{{getRateClasses(existingContract.accounts)}}</p>
                        <p class="accountInfoBorder">Account Number(s)</p>
                        <p class="subUniqueTitle">{{getAccountNumbers(existingContract.accounts)}}</p>
                        <p class="accountInfoBorder">Price</p>
                        <p class="subUniqueTitle">{{existingContract.getSalesPrice() | currency:'USD':'symbol':'1.5-5'}}/kWh</p>
                        <p class="accountInfoBorder">Service Start</p>
                        <p class="subUniqueTitle">1st meter read on or after {{existingContract.termFrom | date:'shortDate'}}</p>
                        <p class="accountInfoBorder">Service End</p>
                        <p class="subUniqueTitle">1st meter read on or after {{existingContract.termTo | date:'shortDate'}}</p>
                        <div class="card-sub-block-background">BUYER</div>
                        <div>
                            <p class="accountInfoBorder">First Name</p>
                            <p class="subUniqueTitle">{{existingContract.user.firstName || '-'}}</p>
                            <p class="accountInfoBorder">Last Name</p>
                            <p class="subUniqueTitle">{{existingContract.user.lastName || '-'}}</p>
                            <p class="accountInfoBorder">Company Name</p>
                            <p class="subUniqueTitle">{{(existingContract.user.company != null) ? existingContract.user.company.name : '-'}}</p>
                            <p class="accountInfoBorder">Address Line 1</p>
                            <p class="subUniqueTitle">{{existingContract.user.addressLine1 || '-'}}</p>
                            <p class="accountInfoBorder">Address Line 2</p>
                            <p class="subUniqueTitle">{{existingContract.user.addressLine2 || '-'}}</p>
                            <p class="accountInfoBorder">City</p>
                            <p class="subUniqueTitle">{{existingContract.user.city || '-'}}</p>
                            <p class="accountInfoBorder">State</p>
                            <p class="subUniqueTitle">{{(existingContract.user.state != null) ? existingContract.user.state.name : '-'}}</p>
                            <p class="accountInfoBorder">Zip</p>
                            <p class="subUniqueTitle">{{existingContract.user.zip || '-'}}</p>
                            <p class="accountInfoBorder">Telephone</p>
                            <p class="subUniqueTitle">{{existingContract.user.phone || '-'}}</p>
                            <p class="accountInfoBorder">E-mail</p>
                            <p class="subUniqueTitle">{{existingContract.user.email || '-'}}</p>
                            @if (existingContract.user.company != null && existingContract.user.company.taxExempt) {
                            <div>
                                <p class="accountInfoBorder">Tax Exempt</p>
                                <p class="subUniqueTitle">Yes</p>
                                <p class="accountInfoBorder">Federal Tax ID</p>
                                <p class="subUniqueTitle">{{existingContract.user.company.federalTaxID || '-'}}</p>
                            </div>
                            }
                        </div>
                        <div class="card-sub-block-background">SELLER</div>
                        <div>
                            <p class="accountInfoBorder">Company</p>
                            <p class="subUniqueTitle">{{existingContract.supplierName || '-'}}</p>
                        </div>
                    </div>
                </div>
                <div class="mt-10 block-buttons full-width under-card">
                    <button type="button" (click)="deleteExistingContract(existingContract)">Delete Price Plan</button>
                    <button type="button" (click)="editContract(existingContract)">Edit Price Plan</button>
                </div>
            </div>
            }
        </div>
    </div>
</div>
}
